<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Customer Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
              <b-row>
                <b-col lg="7">
                    <b-form-group label-cols-md=2 label="Customer Code">
                      <b-row>
                        <b-col cols="5">
                          <b-form-input v-model="model.CustCode" v-b-tooltip.hover title="if Empty will be auto assigned by system, eg.C1007" ></b-form-input>
                        </b-col>
                        <b-col cols="7">
                          <b-form-radio-group  v-model="model.IsIndividu" name="radioIndividu">
                            <b-form-radio value="0">Badan Hukum/Perusahaan</b-form-radio>
                            <b-form-radio value="1">Individu/Personal</b-form-radio>
                          </b-form-radio-group>
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Customer Name">
                          <b-form-input v-model="model.CustName" :state="!$v.model.CustName.$error" ></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Billing Address">
                          <b-form-input  v-model="model.Address1" :state="!$v.model.Address1.$error"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 >
                          <b-form-input  v-model="model.Address2" ></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label-align-md="right" label="City/State/Province">
                        <b-row>
                          <b-col class="pr-1" cols="8"><b-form-input  v-model="model.City" ></b-form-input></b-col>
                          <b-col class="pl-1" cols="4">                            
                          <b-form-group label-cols=4 label="Post Code">
                                <b-form-input  v-model="model.PostCode" ></b-form-input>
                          </b-form-group>
                          </b-col>
                        </b-row>                      
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Phone">
                        <b-row>
                          <b-col class="pr-1" cols="8">                            
                              <b-input-group>
                                    <b-form-input  v-model="model.PhoneNo" :state="!$v.model.PhoneNo.$error"></b-form-input>                          
                                    <b-input-group-prepend><span class="p-2">Fax.</span></b-input-group-prepend>
                                    <b-form-input  v-model="model.FaxNo" ></b-form-input>
                              </b-input-group>
                          </b-col>
                        </b-row>                      
                    </b-form-group>
                </b-col>
                <b-col lg="5">
                    <b-form-group label-cols-md=2 label="N P W P">
                      <b-row>
                        <b-col cols="5">
                          <b-form-input v-model="model.npwp" :state="!$v.model.npwp.$error"></b-form-input>
                        </b-col>
                        <b-col cols="7">
                        </b-col>
                      </b-row>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Nama WP">
                          <b-form-input v-model="model.npwp_name" :state="!$v.model.npwp_name.$error"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Alamat WP">
                          <b-form-input  v-model="model.npwp_address1" :state="!$v.model.npwp_address1.$error"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Customer Group"  label-align-lg="right" >
                          <b-form-select v-model="model.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Group/Holding ">
                      <b-input-group >
                          <b-form-input readonly v-model="model.holding" ></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="lkuCustomerShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                          <b-input-group-append>
                                  <b-form-checkbox class="ml-1 mt-2" v-model="model.bill2group" value="1" unchecked-value="0">Billing ke Group</b-form-checkbox>
                          </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="8">
                  <b-card title="Contacts">
                    <b-table
                        class="mb-0"
                        ref="tblContact"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="contact.items"
                        :fields="contact.fields"
                        :current-page="contact.page"
                        :per-page="contact.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editContact(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delContact(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                            <b-row class="ml-5 mt-2 mr-3">
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Contact Name" >
                                        <b-form-input v-model="contact.obj.contact_name" :state="!$v.contact.obj.contact_name.$error"></b-form-input>
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Job Position/Title" >
                                        <b-form-input v-model="contact.obj.contact_position" :state="!$v.contact.obj.contact_position.$error"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col class="pr-4" cols="6">
                                    <b-form-group  label-cols=3  label="Contact Phone" >
                                        <b-form-input v-model="contact.obj.contact_phone" :state="!$v.contact.obj.contact_phone.$error"></b-form-input>
                                    </b-form-group>
                                    <b-form-group  label-cols=3  label="Contact Email" >
                                        <b-form-input v-model="contact.obj.contact_email" type="email" :state="!$v.contact.obj.contact_email.$error"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center mb-2">
                                <div style="width:450px;">
                                    <b-input-group >
                                        <b-input-group-prepend><span class="p-2">Add New Contact after update</span></b-input-group-prepend>
                                        <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                        <b-input-group-append>
                                            <b-button class="btn btn-success mr-1" @click="saveContact()">Update</b-button>
                                        </b-input-group-append>
                                        <b-input-group-append>
                                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>

                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="btn btn-primary ml-3" @click="addContact" >Add Contact</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(contact.page - 1) * contact.limit + 1}}
                          to
                          {{contact.page * contact.limit}}
                          of
                          {{contact.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="contact.total"
                          :per-page="contact.limit"
                          v-model="contact.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
                <b-col lg="4">
                    <b-form-group label-cols-md=2 label="Status">
                          <b-form-checkbox class="ml-1 mt-2" v-model="model.isactive" value="1" unchecked-value="0">Inactive</b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Sales AE">
                          <b-form-input  v-model="model.SalesCode" placeholder="sales"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md=2 label="Collector">
                          <b-form-input  v-model="model.collector" ></b-form-input>
                    </b-form-group>
                </b-col>
              </b-row>
                  <b-row class="justify-content-center mb-2">
                      <div style="width:450px;">
                          <b-input-group >
                              <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                              <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                              <b-input-group-append>
                                  <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                              </b-input-group-append>
                              <b-input-group-append>
                                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                              </b-input-group-append>
                          </b-input-group>
                      </div>
                  </b-row>
    </b-card>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        

  </div>
</template>

<script>
import customer from "../../apis/bakerycustomer";
import lkuCustomer from "../lookup/lkuCustomer";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            CustName: { required },
            Address1: { required },
            PhoneNo: { required },
            npwp: { required },
            npwp_name: { required },
            npwp_address1: { required }
        },
    contact: {
        obj: {
            contact_name: { required },
            contact_position: { required },
            contact_phone: {required : (function() {
                if (this.contact.obj.contact_email) {
                    return true;
                } else if (!(this.contact.obj.contact_phone)){
                    return false;
                } else return true;
            })},
            contact_email: {required : (function() {
                if (this.contact.obj.contact_phone) {
                    return true;
                } else if (!(this.contact.obj.contact_email)){
                    return false;
                } else return true;
            })}
        }
    },
  }, 
  data () {
    return {
        lkuCustomerShow: false,
        saveEnabled:true,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        model:{CustName:'',Address1:'', PhoneNo:'', npwp:'', npwp_name:'', IsIndividu:0},
        contact: {
            items: [],
            selected:{},
            obj:{contact_name:'', contact_position:'', contact_phone:'', contact_email:''},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "contact_name",
                    label: "Name"
                },
                {
                    key: "contact_position",
                    label: "Job Position/Title"
                },
                {
                    key: "contact_phone",
                    label: "Phone",
                },
                {
                    key: "contact_email",
                    label: "Email",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        group: {
            list: [],
            selected:{},
            obj:{group_name:'', customer_id:''},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "group_name",
                    label: "Group Name"
                },
                {
                    key: "group_code",
                    label: "Group Code"
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        lkuGroupShow:false,
        customerGroups:[{value:'RETAIL', text:'RETAIL'}, {value:'WHOLESHALE', text:'WHOLESHALE'}],
        taxBussinesGroups:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidContact() {
        this.$v.contact.obj.$touch();
        return this.$v.contact.obj.$invalid;
      },
  },
  created: async function() {
      if (this.$route.params.customer_id)  {
          toastr.info('Loading Customer Detail, please wait')
          try {
            const [data, g] = await Promise.all([customer.detail(this.$route.params),  customer.group()]);
            this.customerGroups =g;

            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.holding = `${this.model.Bill2CustName} | ${this.model.Bill2CustNo}`; 
            this.contact.items = data[1];
            this.group.items = data[2];
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }
      } else {
        this.customerGroups =await customer.group();
      }

  },
  methods:{
    onSelectLkuCustomer: async function (_selected) {
        this.model.holding = _selected.CustName + ' | ' + _selected.CustCode;
        this.model.Bill2CustNo = _selected.CustCode;
        this.model.Bill2CustName = _selected.CustName;
        this.model.Bill2CustId = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    addGroup : function () {
        this.lkuGroupShow=true;
    },
    delGroup: function (index) {
        if (index > -1) {
        this.group.list.splice(index, 1);
        }
        this.group.total=this.group.list.length;
    },
    onSelectLkuGroup: function (_selected) {
        const obj={
                  group_code : _selected.group_code,
                  group_name : _selected.group_name,
                  }
        this.group.list.push(obj);
        this.group.total=this.group.list.length;
        this.lkuGroupShow=false;
    },
    closeContact: function(){
        const opened= this.contact.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addContact : function () {
      this.closeContact();
        const obj={_showDetails:true};
        this.contact.selected = obj;
        for (var key in this.contact.obj) {
            this.contact.obj[key] = '';
        }
        this.contact.items.push(obj);
        this.contact.total=this.contact.items.length;
    },
    editContact : function (obj,callback) {
      this.closeContact();
        this.contact.selected = obj;
        for (var key in this.contact.obj) {
            this.contact.obj[key] = '';
        }
        for (var key in obj) {
            this.contact.obj[key] = obj[key];
        }
        callback();
    },
    delContact: function (index) {
        if (index > -1) {
        this.contact.items.splice(index, 1);
        }
        this.contact.total=this.contact.items.length;
        this.calcTotalDtlPaym();
    },
    saveContact: function(callback){
        if (this.invalidContact) {
            console.log('validation contact : ', this.$v.contact.obj);
            console.log('selected contact : ',this.contact.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.contact.obj) {
                this.contact.selected[key] = this.contact.obj[key];
            }
            this.contact.selected._showDetails=false;
            if (callback) callback();
            if (this.inputLineBerlanjut==1) {
                this.addContact();
                this.$v.contact.obj.$reset();                        
            }

        }
    },
    save: async function(){
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;            
        this.model.npwp_name = this.model.npwp_name || this.model.CustName;
        this.model.npwp_address1 = this.model.npwp_address1 || this.model.Address1 ;
        this.model.npwp_address2 = this.model.npwp_address2 || this.model.Address2;
        this.model.npwp_city = this.model.npwp_city || this.model.City;
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.contacts = this.contact.items.reduce((newArr, item) => {
                  if ((item.contact_name || '') != '')
                  {
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              data.groups=this.group.list;
              this.model.customer_group='';
              this.group.list.forEach(row => {
                    if(this.model.customer_group==''){
                        this.model.customer_group=row.group_code
                    }else{
                        this.model.customer_group+=','+row.group_code
                    }                
              });
              // await customer.save(data);
              // this.close();
              const hasil= await customer.save(data);
              toastr.success(`Success, Number ${hasil.CustCode}`, "Save Customer",10000);

              if (this.inputBerlanjut==0){
                  this.close();
              } else {
                  this.saveEnabled=true;            
                  for (var key in this.model) {
                      this.model[key] = '';
                  }
                  this.contact.items=[];

                  this.$v.model.$reset();                        
              }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && !this.$store.state.prevRoute.name.includes('customerfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push('home');
      }
    },    

  }
}
</script>